/**
 * LF: Scrollbar width probe.
 *
 * Exposes the real, live gap between window.innerWidth (viewport including
 * the vertical scrollbar's own track) and document.documentElement.clientWidth
 * (viewport excluding it) as --lf-scrollbar-w on the root element.
 *
 * lf-video-banner.liquid's 100vw + negative-50vw full-bleed trick uses this
 * to cancel that gap out — otherwise the banner bleeds past both edges of
 * the page by half the scrollbar's width whenever the page is tall enough
 * to show one, producing a site-wide horizontal scrollbar on every lf-cl2-*
 * collection page.
 *
 * Idempotent and shared: every lf-video-banner instance on a page loads this
 * same file, but the write is a no-op past the first call, and only one
 * resize listener is ever attached (guarded by window.__lfScrollbarWidthInit).
 */
(function () {
  if (window.__lfScrollbarWidthInit) return;
  window.__lfScrollbarWidthInit = true;

  function measure() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    if (w < 0) w = 0;
    document.documentElement.style.setProperty('--lf-scrollbar-w', w + 'px');
  }

  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
})();
